export const SHOW_MODAL_QUERY_PARAM = "show_modal";

export const MODAL_IDENTIFIER_QUERY_PARAM = "modal_identifier";
